<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Modificar servicio">
          <Form :service_id=id ></Form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Form from './Form'
import api from '@/helpers/api'
export default {
  components: { Form },
  data(){
    return {
      id: this.$route.params.id
    }
  },
  mounted(){
    api.get(`/service/${this.id}`).then(response => {
      this.service = response.service
      console.log("ID applicant: ",this.service.applicant_id)
      this.service.__type = 'service'
      console.log({'service': this.service})
      if(!this.$can('edit', this.service)){ //{'service': this.service})){
        this.$toastr.warning('Este servicio no está viculado a su empresa', 'Servicio', {positionClass: "toast-top-center", closeButton: true});
        //goBack()
        this.$router.push('/dashboard')
      }
    })        
  }
}
</script>
